"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useDisabledCopyButton = require("./useDisabledCopyButton");

Object.keys(_useDisabledCopyButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useDisabledCopyButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDisabledCopyButton[key];
    }
  });
});

var _useGetPartnerKey = require("./useGetPartnerKey");

Object.keys(_useGetPartnerKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetPartnerKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetPartnerKey[key];
    }
  });
});

var _useUtmParams = require("./useUtmParams");

Object.keys(_useUtmParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useUtmParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUtmParams[key];
    }
  });
});

var _useGetWhitelabelDomain = require("./useGetWhitelabelDomain");

Object.keys(_useGetWhitelabelDomain).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetWhitelabelDomain[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetWhitelabelDomain[key];
    }
  });
});

var _useGetWhitelabelLogo = require("./useGetWhitelabelLogo");

Object.keys(_useGetWhitelabelLogo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetWhitelabelLogo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetWhitelabelLogo[key];
    }
  });
});

var _useGetIsWhitelabel = require("./useGetIsWhitelabel");

Object.keys(_useGetIsWhitelabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetIsWhitelabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetIsWhitelabel[key];
    }
  });
});

var _useGetIsPassLtAflt = require("./useGetIsPassLtAflt");

Object.keys(_useGetIsPassLtAflt).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetIsPassLtAflt[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetIsPassLtAflt[key];
    }
  });
});

var _useConstructorContextDispatch = require("./useConstructorContextDispatch");

Object.keys(_useConstructorContextDispatch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useConstructorContextDispatch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useConstructorContextDispatch[key];
    }
  });
});

var _useGetWhitelabelName = require("./useGetWhitelabelName");

Object.keys(_useGetWhitelabelName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetWhitelabelName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetWhitelabelName[key];
    }
  });
});

var _useConstructorContextState = require("./useConstructorContextState");

Object.keys(_useConstructorContextState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useConstructorContextState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useConstructorContextState[key];
    }
  });
});

var _useGetBaseQueryParams = require("./useGetBaseQueryParams");

Object.keys(_useGetBaseQueryParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetBaseQueryParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetBaseQueryParams[key];
    }
  });
});

var _useGetWidgetName = require("./useGetWidgetName");

Object.keys(_useGetWidgetName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetWidgetName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetWidgetName[key];
    }
  });
});

var _useGetRedirect = require("./useGetRedirect");

Object.keys(_useGetRedirect).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetRedirect[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetRedirect[key];
    }
  });
});

var _useGetSearchParams = require("./useGetSearchParams");

Object.keys(_useGetSearchParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetSearchParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetSearchParams[key];
    }
  });
});

var _useGetSearchType = require("./useGetSearchType");

Object.keys(_useGetSearchType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetSearchType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetSearchType[key];
    }
  });
});

var _useGetTrackerParams = require("./useGetTrackerParams");

Object.keys(_useGetTrackerParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetTrackerParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetTrackerParams[key];
    }
  });
});

var _useTracker = require("./useTracker");

Object.keys(_useTracker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTracker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useTracker[key];
    }
  });
});